import { Container, Typography, Grid, TextField } from "@mui/material";
import React from "react";
import GlobalButton from "../button";

const textFieldStyle = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "text.white",
  },
};

const MessageBox = () => {
  return (
    <Container sx={{ maxWidth: "600px !important" }}>
      <Typography
        variant="heading_pr"
        component={"h1"}
        textAlign={"center"}
        color={"text.white"}
        lineHeight={"normal"}
      >
        We Will Resolve Your Issue With In 24 Hours
      </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color={"text.white"}>
            Title
          </Typography>
          <TextField sx={textFieldStyle} variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" fontWeight={600} color={"text.white"}>
            Message
          </Typography>
          <TextField
            sx={textFieldStyle}
            variant="outlined"
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <GlobalButton
            btnText={"Send"}
            styleProps={{
              width: "100%",
              height: 45,
              backgroundColor: "text.orangeRed",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default MessageBox;
